import {useEffect, useState} from 'react';

export const usePageAnchor = () => {
    const [anchor, setAnchor] = useState('');

    useEffect(() => {
        if ('undefined' !== typeof window) {
            const hash = window.location.hash;
            setAnchor(hash.replace('#', ''));
        }
    }, []);

    return anchor;
};
